import moment from 'moment';
import { useState } from 'react';
import useClickOutside from '../../../../useClickOutside';

export const ColumnAccountType = (translate, warning, handleEdit, langLocal) => {
    const [options, setOptions] = useState(false)
    const [row_id, setRowId] = useState(null)
    let domNode = useClickOutside(() => {
        setOptions(false);
        setRowId(null)
    });
    const columns = [
        {
            name: <span className="color_spann">{translate('id')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['id']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('name')}</span>, sortable: true,
            cell: (row) => (
                <span>{row['name']}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('created_at')}</span>,
            cell: (row) => (
                <span>{moment(row['created_at']).format("YYYY-MM-DD")}</span>
            )
        },
        {
            name: <span className="color_spann">{translate('actions')}</span>,
            cell: (row, index) => (
                
                <div>
                <i className='fa fa-edit icon_edit' onClick={(e) => handleEdit(e, row)} ></i>
                <i className='fa fa-trash icon_trash' onClick={() => warning(row)} ></i>
            </div>
            )
        }
    ]
    return {
        columns
    }
}
